import { Container } from "../../../components/Container/Container";
import { Seo } from "../../../components/Seo/Seo";

export const NotFoundErrorPage = () => {
	return (
		<>
			<Seo title="Page not found" description="The page you requested could not been found." />
			<Container>
				<h1 className="mb-5">Oops!</h1>
				<p className="text-base">404 page not found.</p>
			</Container>
		</>
	);
};
